import {previewBlob} from './preview-limit'
import {saveBlob} from '@/api/fileCenter'
import store from '@/store'
export function approvalAttachment(file){
 if(!file||typeof file.url!=='string'||!file.url.trim())throw new Error('附件地址无效')
 const url=new URL(String(file && file.url || ''),location.href)
 if(!['https:','http:'].includes(url.protocol)||url.username||url.password)throw new Error('附件地址无效')
 return {url:url.href,name:String(file.name||file.fileName||'附件'),size:Number(file.size||file.fileSize)||0,mediaType:file.mediaType||''}
}
export function attachmentBuffer(blob){return typeof blob.arrayBuffer==='function'?blob.arrayBuffer():new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(reader.result);reader.onerror=()=>reject(new Error('附件读取失败'));reader.readAsArrayBuffer(blob)})}
export async function attachmentBlob(file,max=0){
 const value=approvalAttachment(file)
 if(max&&value.size>max)throw new Error('文件超过200MB在线预览上限，请下载后打开')
 const response=await fetch(value.url,{credentials:'omit',referrerPolicy:'no-referrer'})
 if(!response.ok)throw new Error('附件读取失败，请检查文件是否仍然有效')
 if(max&&Number(response.headers.get('Content-Length'))>max)throw new Error('文件超过200MB，请下载后打开')
 const blob=await previewBlob(response,max)
 if(max&&blob.size>max)throw new Error('文件超过200MB，请下载后打开')
 return blob
}
export async function downloadApprovalAttachment(file){saveBlob(await attachmentBlob(file),file.name||file.fileName||'附件')}
export async function legacyApprovalPreview(file,desktop=false){
 const blob=await attachmentBlob(file,200*1024*1024),form=new FormData()
 form.append('file',blob,file.name)
 const token=desktop?sessionStorage.getItem('hxt-token'):store.state.token
 const base=desktop?'/api/workbench':(process.env.VUE_APP_API_BASE_URL||'')
 const response=await fetch(base+'/oa/approval/attachments/preview',{method:'POST',headers:{Authorization:'Bearer '+token,'Win-Type':'3'},body:form})
 const result=await response.json()
 if(!response.ok||result.code!==0)throw new Error(result.message||'旧版文档预览失败，请下载原文件查看')
 return result.data.html
}
export function desktopAttachmentPreview(file){
 return new Promise(resolve=>{
  const parent=window.parent;if(parent===window){resolve(false);return}
  const requestId=Date.now().toString(36)+Math.random().toString(36).slice(2)
  function finish(value){clearTimeout(timer);window.removeEventListener('message',message);resolve(value)}
  function message(event){if(event.source===parent&&event.origin===location.origin&&event.data&&event.data.type==='hxt-approval-file-preview-result'&&event.data.requestId===requestId)finish(event.data.handled===true)}
  const timer=setTimeout(()=>finish(false),1000)
  window.addEventListener('message',message)
  parent.postMessage({type:'hxt-approval-file-preview',requestId,file:approvalAttachment(file)},location.origin)
 })
}
